export default __webpack_public_path__ + "static/media/reMobidycDefault.6aa48016.png";